import { IconPropsBase } from './IconPropsBase';

export default function MarketplaceSeatGeekIcon({ size = 24, color = 'currentColor' }: IconPropsBase) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fill={color} d="M10.2,21.96c-1.33-.17-3.02-.77-4.06-1.44l-.51-.33v-4.98l.69.52c1.51,1.15,3.03,1.87,4.61,2.19,1.83.37,2.88-.2,2.88-1.56,0-.55-.02-.59-.56-1.11-.39-.37-1.04-.79-2.08-1.33-3.76-1.96-5.11-3.38-5.45-5.72-.39-2.73,1.17-4.93,4.22-5.93,1.3-.43,4.79-.35,6.98.16l.51.12v.7c0,.39-.03,1.38-.07,2.2l-.07,1.5-.5-.24c-.27-.13-.92-.37-1.45-.53-.82-.25-1.15-.29-2.38-.3-1.29,0-1.48.01-1.88.23-.51.27-.75.57-.84,1.05-.15.8.53,1.43,2.76,2.53.89.44,1.98,1.04,2.41,1.33,1.57,1.03,2.5,2.28,2.81,3.72.67,3.18-1.18,6.16-4.36,7.02-.63.17-2.9.29-3.66.19h0Z"/>
    </svg>
  );
}
